import _ from 'lodash';

/**
 * Whether a row of the lead's Campaigns tab is a campaign the lead is still in,
 * i.e. one it can be removed from. Ongoing and one-time campaigns both run
 * multi-day sequences, so this does not depend on `ongoing`: only on the lead
 * having neither left nor received every message.
 */
export function leadStillInCampaign(leadCampaign) {
    return ! ['Left', 'Finished'].includes(_.upperFirst(leadCampaign.status));
}
